<template>
	<div class="input-group mb-1">
		<input :placeholder="placeholder" class="form-control" v-model="text" @keydown.enter.prevent="onSearch" ref="input" />
		<div class="input-group-append">
			<button type="button" class="btn btn-trig" @click.stop.prevent="onSearch" v-if="!searchAway">
				<i class="icon icon-search1"></i>
			</button>
			<button type="button" class="btn btn-trig" @click.stop.prevent="onClear">
				<i class="icon icon-x"></i>
			</button>
		</div>
	</div>
</template>

<script lang="ts">

import { ref, defineComponent, watch, nextTick } from 'vue';

export default defineComponent({
	props: {
		modelValue: {
			type: String,
			default: ''
		},
		searchAway: {
			type: Boolean,
			default: false
		},
		delay: {
			type: Number,
			default: 250
		},
		placeholder: {
			type: String,
			default: 'Введите строку для поиска...'
		},
		search: {
			type: Boolean,
			default: true
		},
		clear: {
			type: Boolean,
			default: true
		}
	},

	emits: ['update:modelValue'],

	setup(props: any, { emit }: { emit: any }) {
		const input = ref(null);

		const text = ref<string>(props.modelValue);

		if (props.searchAway) {
			let handle: any = null;
			watch(
				text,
				(newValue) => {
					if (handle != null) clearTimeout(handle);

					handle = setTimeout(() => {
						emit('update:modelValue', newValue);
					}, props.delay);
				}
			)
		} else {
			// Если searchAway отключен, обновляем только при явных действиях
			watch(
				() => props.modelValue,
				(value) => {
					if (text.value !== value) {
						text.value = value;
					}
				}
			)
		}

		const onSearch = async () => {
			const value = text.value || '';
			// Принудительно обновляем значение перед эмитом
			if (text.value !== value) {
				text.value = value;
			}
			emit('update:modelValue', value);
			// Ждем обновления, чтобы гарантировать, что watch сработает
			await nextTick();
		}

		const onClear = async () => {
			// Очищаем локальное значение
			text.value = '';
			// Эмитим событие - важно эмитить именно пустую строку, а не undefined
			emit('update:modelValue', '');
			// Ждем обновления, чтобы гарантировать, что watch сработает
			await nextTick();
		};

		return {
			onClear, onSearch, text, input
		}
	}
})
</script>

<style></style>
